define.alias("shared/components/shared/ui/social-set-switcher/social-set", "media/components/shared/ui/social-set-switcher/social-set");